import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'

import { QUERY_KEYS } from '../../../lib/queryKeys'
import { getUserPackages } from '../../../services/packages'

export const useUserPackages = selectFn => {
  const { loggedUser } = useSelector(state => state.user)
  return useQuery({
    queryKey: [QUERY_KEYS.USER_PACKAGES],
    queryFn: getUserPackages,
    enabled: !!loggedUser?.Username,
    select: selectFn,
  })
}
